import { render, staticRenderFns } from "./upcomingshipments.vue?vue&type=template&id=23ef06f0"
import script from "./upcomingshipments.vue?vue&type=script&lang=js"
export * from "./upcomingshipments.vue?vue&type=script&lang=js"
import style0 from "./upcomingshipments.vue?vue&type=style&index=0&id=23ef06f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports